import React, { Component } from 'react';
import { _Alert, variable, _post, _getToken, _isLogin } from './Function';
import ModalGenaral from './Modal.Genaral';
import ModalAddress from './Modal.Address';
import '../css/Dashboard.css';

class DashboardInfo extends Component {
    constructor(props) {
        super(props);
        this.state={
            onShowGenaralModal: false,
            onShowAddressModal: false,
            onComponent: '',
            modalGenaralInfo: { mobile: '', tel: '', email: ''},
            current_address: {
                c_address_no: '',
                c_address_moo: '',
                c_address_village: '',
                c_address_road: '',
                c_address_soi: '',
                c_district_id: 0,
                c_amphur_id: 0,
                c_province_id: 0,
                c_zipcode: ''
            }
        }
        _isLogin().then( value => { 
            if ( value ) this.getDashboard();
        });
    }
    
    getDashboard = () => {
        let param = { token: _getToken(), platform: variable().platform };
        _post('web.dashboard.php', param)
        .then(res => {
          if ( res.data.status ) {
            this.props.onLoading(false);
            this.setState({ 
                dashboard: res.data.data, 
                is_dashboard: (res.data.status === 1) ? true : false,
                modalGenaralInfo: { 
                    mobile: (res.data.data.mobile === '-') ? '' : res.data.data.mobile, 
                    tel: (res.data.data.tel === '-') ? '' : res.data.data.tel,
                    email: (res.data.data.email === '-') ? '' : res.data.data.email,
                },
                current_address: {
                    c_address_no: res.data.data.address_current_update.address_no,
                    c_address_moo: res.data.data.address_current_update.address_moo,
                    c_address_village: res.data.data.address_current_update.address_village,
                    c_address_road: res.data.data.address_current_update.address_road,
                    c_address_soi: res.data.data.address_current_update.address_soi,
                    c_district_id: res.data.data.address_current_update.district_id,
                    c_amphur_id: res.data.data.address_current_update.amphur_id,
                    c_province_id: res.data.data.address_current_update.province_id,
                    c_zipcode: res.data.data.address_current_update.zipcode
              }
            }); 
          } else {
            this.props.onLoading(false);
            if ( res.data.responseText === 101 ) {
                localStorage.clear();
                _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
            } else {
                _Alert('modify', 'error', 'แจ้งเตือน', res.data.responseText);
            }

          }
        }).catch(err => { 
            this.props.onLoading(false);
          _Alert('error'); 
        });
    }

    openGenaralModal(t) { this.setState({ onShowGenaralModal: true, onComponent: t }) }

    closeGenaralModal = () => { this.setState({ onShowGenaralModal: false, onComponent: '' }) }

    openAddressModal() { this.setState({ onShowAddressModal: true }) }

    closeAddressModal = () => { this.setState({ onShowAddressModal: false }) }

    render() {
        return (
            <div>
                <ModalGenaral 
                    onComponent={this.state.onComponent} 
                    onShowGenaralModal={this.state.onShowGenaralModal} 
                    onInfo={this.state.modalGenaralInfo} 
                    onFallback={this.getDashboard} 
                    closeGenaralModal={this.closeGenaralModal}
                />

                <ModalAddress 
                    onShowAddressModal={this.state.onShowAddressModal} 
                    closeAddressModal={this.closeAddressModal}
                    onCurrentAddress={this.state.current_address}
                    onFallback={this.getDashboard} 
                />

                <div className="card">
                    <div className="card-title">
                    <div className="card-icon"><i className="fas fa-user"></i></div>
                    <div className="card-title-text">ข้อมูลสมาชิก</div>
                    </div>
                    <div className="card-content">
                    { (this.state.is_dashboard ) ? (
                        <div>
                        <img className="card-content-img" src={this.state.dashboard.user_img} />
                        <div>
                            <div className="left">เลขที่สมาชิก</div>
                            <div className="right-side right">{this.state.dashboard.member_id}</div>
                        </div>
                        <div>
                            <div className="left">ชื่อ - สกุล</div>
                            <div className="right-side right">{this.state.dashboard.member_name}</div>
                        </div>
                        <div>
                            <div className="left">สังกัด</div>
                            <div className="right-side right right-limit">{this.state.dashboard.affiliation}</div>
                        </div> 
                        <div>
                            <div className="left">ประเภทสมาชิก</div>
                            <div className="right-side right">{this.state.dashboard.member_type}</div>
                        </div>
                        <div>
                            <div className="left">วันเดือนปีเกิด</div>
                            <div className="right-side right">
                            {this.state.dashboard.birthday}
                            <div className="for-pc">
                                <div className="right-title">อายุ</div>
                                <div className="right">{this.state.dashboard.age}</div>
                            </div>
                            </div>
                        </div>
                        <div className="for-mobile">
                            <div className="left">อายุ</div>
                            <div className="right-side right">{this.state.dashboard.age}</div>
                        </div>
                        <div>
                            <div className="left">เลขบัตรประชาชน</div>
                            <div className="right-side right">{this.state.dashboard.id_card}</div>
                        </div> 
                        <div>
                            <div className="left">ตำแหน่ง</div>
                            <div className="right-side right">
                            {this.state.dashboard.position}
                            <div className="for-pc">
                                <div className="right-title">เงินเดือน</div>
                                <div className="right">{this.state.dashboard.salary} บาท</div>
                                <div className="right-title">เงินได้อื่น ๆ</div>
                                <div className="right">{this.state.dashboard.other_income} บาท</div>
                            </div>
                            </div>
                        </div>
                        <div className="for-mobile">
                            <div className="left">เงินเดือน</div>
                            <div className="right-side right">{this.state.dashboard.salary} บาท</div>
                        </div>
                        <div className="for-mobile">
                            <div className="left">เงินได้อื่น ๆ</div>
                            <div className="right-side right">{this.state.dashboard.other_income} บาท</div>
                        </div>
                        <div>
                            <div className="left">วันที่เข้าเป็นสมาชิก</div>
                            <div className="right-side right">
                            {this.state.dashboard.member_date}
                            <div className="for-pc">
                                <div className="right-title">อายุการเป็นสมาชิก</div>
                                <div className="right">{this.state.dashboard.registerDate}</div>
                            </div>
                            </div>
                        </div>
                        <div className="for-mobile">
                            <div className="left">อายุการเป็นสมาชิก</div>
                            <div className="right-side right">{this.state.dashboard.registerDate}</div>
                        </div>
                        <div>
                            <div className="left">ที่อยู่</div>
                            <div className="right-side right">{this.state.dashboard.address_idcard}</div>
                        </div>
                        <div>
                            <div className="left">ที่อยู่ที่ติดต่อได้</div>
                            <div className="right-side right">
                            {this.state.dashboard.address_contract}
                            <span className="edit-data" onClick={(e)=>this.openAddressModal()}><i className="fas fa-pencil-alt edit-icon"></i> แก้ไข</span>
                            </div>
                        </div>
                        <div>
                            <div className="left">โทรศัพท์บ้าน</div>
                            <div className="right-side right">
                            {this.state.dashboard.tel}
                            <span className="edit-data" onClick={(e)=>this.openGenaralModal('tel')}><i className="fas fa-pencil-alt edit-icon"></i> แก้ไข</span>
                            <div className="for-pc">
                                <div className="right-title">โทรศัพท์มือถือ</div>
                                <div className="right">{this.state.dashboard.mobile}<span className="edit-data" onClick={(e)=>this.openGenaralModal('mobile')}><i className="fas fa-pencil-alt edit-icon"></i> แก้ไข</span></div>
                            </div>
                            </div>
                        </div>
                        <div className="for-mobile">
                            <div className="left">โทรศัพท์มือถือ</div>
                            <div className="right-side right">{this.state.dashboard.mobile}<span className="edit-data" onClick={(e)=>this.openGenaralModal('mobile')}><i className="fas fa-pencil-alt edit-icon"></i> แก้ไข</span></div>
                        </div>
                        <div>
                            <div className="left">อีเมล์</div>
                            <div className="right-side right">{this.state.dashboard.email}<span className="edit-data" onClick={(e)=>this.openGenaralModal('email')}><i className="fas fa-pencil-alt edit-icon"></i> แก้ไข</span></div>
                        </div>     
                        </div>
                    ) : (
                        <div className="no-data">ไม่พบข้อมูลสมาชิก</div>
                    )}
                    </div>
                </div>
            </div>
        )
    }
}

export default DashboardInfo;